<template>
	<tr class="md-table-row" v-if="member">
		<!--<td class="md-table-cell">
			<div class="md-table-cell-container">
				<md-avatar class="md-medium">
					<img v-if="member && member.imageURL" :src="member.imageURL" class="user-image">
					<img v-if="!member || !member.imageURL" class="user-image" src="../assets/person.png">
				</md-avatar>
			</div>
		</td><-->
		<td class="md-table-cell"><div class="md-table-cell-container"><span class="display-link" @click="goToProfile()">{{displayName(member)}}</span></div></td>
		<td class="md-table-cell"><div class="md-table-cell-container"><span class="display-link" @click="goToProfile()">{{ member.emails[0] }}</span></div></td>
		<td class="md-table-cell" v-if="$lodash.has(member.request, 'lastRequest')"><div class="md-table-cell-container">{{ member.request.lastRequest | momentDate }}</div></td>
		<td class="md-table-cell" v-else><div class="md-table-cell-container">---</div></td>
		<td class="md-table-cell" v-if="$lodash.has(member.response, 'lastResponse')"><div class="md-table-cell-container">{{ member.response.lastResponse | momentDate }}</div></td>
		<td class="md-table-cell" v-else><div class="md-table-cell-container">---</div></td>
		<td class="md-table-cell" v-if="$lodash.has(member, 'lastFeedback')"><div class="md-table-cell-container">{{ member.lastFeedback | momentDate }}</div></td>
		<td class="md-table-cell" v-else><div class="md-table-cell-container">---</div></td>
		<td class="md-table-cell" v-if="section === 'communityMembers'"><div class="md-table-cell-container">{{ displayStatus(member) }}</div></td>
	</tr>
</template>
<script>
export default {
	props: ["member", "section"],
  methods: {
    goToProfile: function() {
      let route = this.$router.resolve({path: `/members/${this.member._id}`});
      window.open(route.href, '_blank');
    },
    displayName(member) {
  		return this.$lodash.has(member, 'first') ? member.first + ' ' + member.last : member.displayName;
		},
		displayStatus(member) {
				return member.unsubscribe && member.unsubscribe.status === 'unsubscribed' ? 'Inactive' : '---';
  	}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Member.vue